"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetIdToOnRamperTokenList = exports.onRamperTokenIdToAssetId = exports.getOnRamperSupportedAssets = exports.AssetIdToOnRamperIdMap = void 0;
const entries_1 = __importDefault(require("lodash/entries"));
exports.AssetIdToOnRamperIdMap = {
    'eip155:1/erc20:0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9': ['aave_ethereum'],
    'eip155:1/erc20:0x4d224452801aced8b2f0aebe155379bb5d594381': ['ape_ethereum'],
    'eip155:56/bep20:0x13616f44ba82d63c8c0dc3ff843d36a8ec1c05a9': ['ava_bsc'],
    'eip155:1/erc20:0x442b153f6f61c0c99a33aa4170dcb31e1abda1d0': ['ava_ethereum'],
    'eip155:1/erc20:0xbb0e17ef65f82ab018d8edd776e8dd940327b28b': ['axs_ethereum'],
    'eip155:1/erc20:0x0d8775f648430679a709e98d2b0cb6250d2887ef': ['bat_ethereum'],
    'eip155:56/bep20:0x101d82428437127bf1608f699cd651e6abf9766e': ['bat_bsc'],
    'eip155:1/erc20:0x85c4edc43724e954e5849caaab61a26a9cb65f1b': ['bch_ethereum'],
    'eip155:56/bep20:0x8ff795a6f4d97e7887c79bea79aba5cc76444adf': ['bch_bsc'],
    'eip155:1/erc20:0xb8c77482e45f1f44de1745f52c74426c631bdd52': ['bnb_ethereum'],
    'eip155:56/slip44:60': ['bnb_bsc'],
    'eip155:56/bep20:0xe9e7cea3dedca5984780bafc599bd69add087d56': ['busd_bsc'],
    'eip155:10/erc20:0x9c9e5fd8bbc25984b178fdce6117defa39d2db39': ['busd_optimism'],
    'eip155:1/erc20:0x3506424f91fd33084466f402d5d97f05f8e3b4af': ['chz_ethereum'],
    'eip155:1/erc20:0xc00e94cb662c3520282e6f5717214004a7f26888': ['comp_ethereum'],
    'eip155:1/erc20:0x6b175474e89094c44da98b954eedeac495271d0f': ['dai_ethereum'],
    'eip155:10/erc20:0xda10009cbd5d07dd0cecc66161fc93d7c9000da1': ['dai_optimism'],
    'eip155:56/bep20:0xbf7c81fff98bbe61b40ed186e4afd6ddd01337fe': ['egld_bsc'],
    'eip155:1/erc20:0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c': ['enj_ethereum'],
    'eip155:56/bep20:0x56b6fb708fc5732dec1afc8d8556423a2edccbd6': ['eos_bsc'],
    'eip155:1/slip44:60': ['eth'],
    'eip155:10/slip44:60': ['eth_optimism'],
    'eip155:137/erc20:0x7ceb23fd6bc0add59e62ac25578270cff1b9f619': ['weth_polygon'],
    'eip155:100/erc20:0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1': ['weth_gnosis'],
    'eip155:1/erc20:0x8e16bf47065fe843a82f4399baf5abac4e0822b7': ['fil_ethereum'],
    'eip155:56/bep20:0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153': ['fil_bsc'],
    'eip155:1/erc20:0xf57e7e7c23978c3caec3c3548e3d615c346e79ff': ['imx_ethereum'],
    'eip155:1/erc20:0x4cc19356f2d37338b9802aa8e8fc58b0373296e7': ['key_ethereum'],
    'eip155:1/erc20:0x514910771af9ca656af840dff83e8264ecf986ca': ['link_ethereum'],
    'eip155:56/bep20:0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd': ['link_bsc'],
    'eip155:1/erc20:0x0f5d2fb29fb7d3cfee444a200298f468908cc942': ['mana_ethereum'],
    'eip155:1/erc20:0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0': ['matic_ethereum'],
    'eip155:137/slip44:60': ['matic_polygon'],
    'eip155:56/bep20:0xd944f1d1e9d5f9bb90b62f9d45e447d989580782': ['iota_bsc'],
    'eip155:1/erc20:0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2': ['mkr_ethereum'],
    'eip155:1/erc20:0x75231f58b43240c9718dd58b4967c5114342a86c': ['okb_ethereum'],
    'eip155:1/erc20:0x3593d125a4f7849a1b059e64f4517a86dd60c95d': ['om_ethereum'],
    'eip155:1/erc20:0xd26114cd6ee289accf82350c8d8487fedb8a0c07': ['omg_ethereum'],
    'eip155:1/erc20:0x0258f474786ddfd37abce6df6bbb1dd5dfc4434a': ['orn_ethereum'],
    'eip155:56/bep20:0xe4ca1f75eca6214393fce1c1b316c237664eaa8e': ['orn_bsc'],
    'eip155:1/erc20:0xaf9f549774ecedbd0966c52f250acc548d3f36e5': ['rfuel_ethereum'],
    'cosmos:thorchain-mainnet-v1/slip44:931': ['rune_thorchain'],
    'eip155:1/erc20:0x3845badade8e6dff049820680d1f14bd3903a5d0': ['sand_ethereum'],
    'eip155:56/bep20:0x67b725d7e342d7b611fa85e859df9697d9378b2e': ['sand_bsc'],
    'eip155:137/erc20:0xbbba073c31bf03b8acf7c28ef0738decf3695683': ['sand_polygon'],
    'eip155:1/erc20:0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce': ['shib_ethereum'],
    'eip155:1/erc20:0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f': ['snx_ethereum'],
    'eip155:56/bep20:0x9ac983826058b8a9c7aa1c9171441191232e8404': ['snx_bsc'],
    'eip155:10/erc20:0x8700daec35af8ff88c16bdf0418774cb3d7599b4': ['snx_optimism'],
    'eip155:1/erc20:0x476c5e26a75bd202a9683ffd34359c0cc15be0ff': ['srm_ethereum'],
    'eip155:1/erc20:0xa62cc35625b0c8dc1faea39d33625bb4c15bd71c': ['stmx_ethereum'],
    'eip155:1/erc20:0x05d3606d5c81eb9b7b18530995ec9b29da05faba': ['tomo_ethereum'],
    'eip155:1/erc20:0x0000000000085d4780b73119b644ae5ecd22b376': ['tusd_ethereum'],
    'eip155:56/bep20:0x14016e85a25aeb13065688cafb43044c2ef86784': ['tusd_bsc'],
    'eip155:1/erc20:0x1f9840a85d5af5bf1d1762f925bdaddc4201f984': ['uni_ethereum'],
    'eip155:1/erc20:0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': ['usdc_ethereum'],
    'eip155:100/erc20:0xddafbb505ad214d7b80b1f830fccc89b60fb7a83': ['usdc_gnosis'],
    'eip155:10/erc20:0x7f5c764cbc14f9669b88837ca1490cca17c31607': ['usdc_optimism'],
    'eip155:137/erc20:0x2791bca1f2de4661ed88a30c99a7a9449aa84174': ['usdc_polygon'],
    'eip155:1/erc20:0xdac17f958d2ee523a2206206994597c13d831ec7': ['usdt_ethereum'],
    'eip155:100/erc20:0x4ecaba5870353805a9f068101a40e0f32ed605c6': ['usdt_gnosis'],
    'eip155:1/erc20:0xdc9ac3c20d1ed0b540df9b1fedc10039df13f99c': ['utk_ethereum'],
    'eip155:56/bep20:0x6fdcdfef7c496407ccb0cec90f9c5aaa1cc8d888': ['vet_bsc'],
    'eip155:137/erc20:0xd0258a3fd00f38aa8090dfee343f10a9d4d30d3f': ['voxel_polygon'],
    'eip155:1/erc20:0x2a79324c19ef2b89ea98b23bc669b7e7c9f8a517': ['waxp_ethereum'],
    'eip155:1/erc20:0x2260fac5e5542a773aa44fbcfedf7c193bc2c599': ['wbtc_ethereum'],
    'eip155:56/bep20:0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c': ['wbtc_bsc'],
    'eip155:100/erc20:0x8e5bbbb09ed1ebde8674cda39a0c169401db4252': ['wbtc_gnosis'],
    'eip155:137/erc20:0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6': ['wbtc_polygon'],
    'eip155:1/erc20:0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': ['weth_ethereum'],
    'eip155:56/bep20:0x43c934a845205f0b514417d757d7235b8f53f1b9': ['xlm_bsc'],
    'eip155:1/erc20:0x39fbbabf11738317a448031930706cd3e612e1b9': ['xrp_ethereum'],
    'eip155:56/bep20:0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe': ['xrp_bsc'],
    'eip155:1/erc20:0xe41d2489571d322189246dafa5ebde1f4699f498': ['zrx_ethereum'],
    'eip155:137/erc20:0x45c32fa6df82ead1e2ef74d17b76547eddfaff89': ['frax_polygon'],
    'eip155:43114/erc20:0xd24c2ad096400b6fbcd2ad8b24e7acbc21a1da64': ['frax_avaxc'],
    'eip155:1/erc20:0xff0a024b66739357c4ed231fb3dbc0c8c22749f5': ['wrx_ethereum'],
    'eip155:56/bep20:0x8e17ed70334c87ece574c9d537bc153d8609e2a3': ['wrx_bsc'],
    'eip155:43114/erc20:0x62edc0692bd897d2295872a9ffcac5425011c661': ['gmx_avaxc'],
    'eip155:1/erc20:0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d': ['ctsi_ethereum'],
    'eip155:56/bep20:0x7e624fa0e1c4abfd309cc15719b7e2580887f570': ['pols_bsc'],
    'eip155:1/erc20:0x83e6f1e41cdd28eaceb20cb649155049fac3d5aa': ['pols_ethereum'],
    'eip155:43114/erc20:0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd': ['joe_avaxc'],
    'eip155:1/erc20:0x249ca82617ec3dfb2589c4c17ab7ec9765350a18': ['verse_ethereum'],
    'eip155:1/erc20:0xba5bde662c17e2adff1075610382b9b691296350': ['rare_ethereum'],
    'eip155:137/erc20:0xc2132d05d31c914a87c6611c10748aeb04b58e8f': ['usdt_polygon'],
    'eip155:56/bep20:0x55d398326f99059ff775485246999027b3197955': ['usdt_bsc'],
    'eip155:43114/erc20:0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7': ['usdt_avaxc'],
    'eip155:43114/erc20:0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e': ['usdc_avaxc'],
    'eip155:56/bep20:0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d': ['usdc_bsc'],
    'eip155:43114/slip44:60': ['avax_avaxc'],
    'eip155:1/erc20:0x3a4f40631a4f906c2bad353ed06de7a5d3fcb430': ['pla_ethereum'],
    'eip155:137/erc20:0x8765f05adce126d70bcdf1b0a48db573316662eb': ['pla_polygon'],
    'eip155:1/erc20:0x32353a6c91143bfd6c7d363b546e62a9a2489a20': ['agld_ethereum'],
    'bip122:000000000019d6689c085ae165831e93/slip44:0': ['btc'],
    'eip155:137/erc20:0x8f3cf7ad23cd3cadbd9735aff958023239c6a063': ['dai_polygon'],
    'cosmos:cosmoshub-4/slip44:118': ['atom_cosmos'],
    'eip155:137/erc20:0xd6df932a45c0f255f85145f286ea0b292b21c90b': ['aave_polygon'],
    'eip155:56/bep20:0xfb6115445bff7b52feb98650c87f44907e58f802': ['aave_bsc'],
    'eip155:1/erc20:0x4e15361fd6b4bb609fa63c81a2be19d873717870': ['ftm_ethereum'],
    'eip155:56/bep20:0xad29abb318791d579433d831ed122afeaf29dcfe': ['ftm_bsc'],
    'eip155:137/erc20:0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4': ['mana_polygon'],
    'eip155:1/erc20:0xf4d2888d29d722226fafa5d9b24f9164c092421e': ['looks_ethereum'],
    'eip155:1/erc20:0x111111111117dc0aa78b770fa6a738034120c302': ['1inch_ethereum'],
    'eip155:1/erc20:0xfa1a856cfa3409cfa145fa4e20eb270df3eb21ab': ['iost_ethereum'],
    'eip155:1/erc20:0x6fb3e0a217407efff7ca062d46c26e5d60a14d69': ['iotx_ethereum'],
    'eip155:56/bep20:0x9678e42cebeb63f23197d726b29b1cb20d0064e5': ['iotx_bsc'],
    'eip155:1/erc20:0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429': ['glm_ethereum'],
    'eip155:1/erc20:0x6b3595068778dd592e39a122f4f5a5cf09c90fe2': ['sushi_ethereum'],
    'eip155:137/erc20:0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a': ['sushi_polygon'],
    'eip155:56/bep20:0x947950bcc74888a40ffa2593c5798f11fc9124c4': ['sushi_bsc'],
    'eip155:1/erc20:0x18aaa7115705e8be94bffebde57af9bfc265b998': ['audio_ethereum'],
    'eip155:1/erc20:0x69af81e73a73b40adf4f3d4223cd9b1ece623074': ['mask_ethereum'],
    'eip155:56/bep20:0x2ed9a5c8c13b93955103b9a7c167b67ef4d568a3': ['mask_bsc'],
    'eip155:1/erc20:0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25': ['slp_ethereum'],
    'eip155:56/bep20:0x070a08beef8d36734dd67a491202ff35a6a16d97': ['slp_bsc'],
    'eip155:56/bep20:0x02dd18e4981da3fc7363fe56f3b81d1860b44ea7': ['scrt_bsc'],
    'eip155:1/erc20:0x6c28aef8977c9b773996d0e8376d2ee379446f2f': ['quick_ethereum'],
    'eip155:137/erc20:0x831753dd7087cac61ab5644b308642cc1c33dc13': ['quick_polygon'],
    'eip155:1/erc20:0xde30da39c46104798bb5aa3fe8b9e0e1f348163f': ['gtc_ethereum'],
    'eip155:56/bep20:0xca3f508b8e4dd382ee878a314789373d80a5190a': ['bifi_bsc'],
    'eip155:1/erc20:0x80c62fe4487e1351b47ba49809ebd60ed085bf52': ['clv_ethereum'],
    'eip155:56/bep20:0x09e889bb4d5b474f561db0491c38702f367a4e4d': ['clv_bsc'],
    'eip155:1/erc20:0x7659ce147d0e714454073a5dd7003544234b6aa0': ['xcad_ethereum'],
    'eip155:137/erc20:0x580a84c73811e1839f75d86d75d88cca0c241ff4': ['qi_polygon'],
    'eip155:56/bep20:0x8729438eb15e2c8b576fcc6aecda6a148776c0f5': ['qi_bsc'],
    'eip155:43114/erc20:0x8729438eb15e2c8b576fcc6aecda6a148776c0f5': ['qi_avaxc'],
    'eip155:56/bep20:0xa179248e50ce5afb507fd8c54e08a66fbac7b6ff': ['fjb_bsc'],
    'eip155:137/erc20:0x82e64f49ed5ec1bc6e43dad4fc8af9bb3a2312ee': ['adai_polygon'],
    'eip155:56/bep20:0x2aa69e8d25c045b659787bc1f03ce47a388db6e8': ['ksm_bsc'],
    'eip155:1/erc20:0x92d6c1e31e14520e676a687f0a93788b716beff5': ['dydx_ethereum'],
    'eip155:1/erc20:0xd533a949740bb3306d119cc777fa900ba034cd52': ['crv_ethereum'],
    'eip155:56/bep20:0x111111111117dc0aa78b770fa6a738034120c302': ['1inch_bsc'],
    'eip155:100/slip44:60': ['xdai_gnosis'],
    'eip155:1/erc20:0x4fabb145d64652a948d72533023f6e7a623c7c53': ['busd_ethereum'],
    'eip155:56/bep20:0x0eb3a705fc54725037cc9e008bdede697f62f335': ['atom_bsc'],
    'eip155:56/bep20:0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3': ['dai_bsc'],
    'eip155:56/bep20:0x3019bf2a2ef8040c242c9a4c5c4bd4c81678b2a1': ['gmt_bsc'],
    'eip155:56/bep20:0x4b0f1812e5df2a09796481ff14017e6005508003': ['twt_bsc'],
    'eip155:56/bep20:0x76f3ce6af26de7a9854dbd153acd8f46a2cf5133': ['glmr_bsc'],
    'eip155:1/erc20:0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b': ['rly_ethereum'],
    'eip155:137/erc20:0x1631244689ec1fecbdd22fb5916e920dfc9b8d30': ['ovr_polygon'],
    'eip155:56/bep20:0x82030cdbd9e4b7c5bb0b811a61da6360d69449cc': ['fevr_bsc'],
    'eip155:1/erc20:0x9fb83c0635de2e815fd1c21b3a292277540c2e8d': ['fevr_ethereum'],
    'eip155:1/erc20:0xc18360217d8f7ab5e7c516566761ea12ce7f9d72': ['ens_ethereum'],
    'eip155:1/erc20:0x8290333cef9e6d528dd5618fb97a76f268f3edd4': ['ankr_ethereum'],
    'eip155:56/bep20:0xf307910a4c7bbc79691fd374889b36d8531b08e3': ['ankr_bsc'],
    'eip155:1/erc20:0x04fa0d235c4abf4bcf4787af4cf447de572ef828': ['uma_ethereum'],
    'eip155:1/erc20:0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e': ['yfi_ethereum'],
    'eip155:1/erc20:0xa1d0e215a23d7030842fc67ce582a6afa3ccab83': ['yfii_ethereum'],
    'eip155:56/bep20:0x7f70642d88cf1c4a3a7abb072b53b929b653eda5': ['yfii_bsc'],
    'eip155:56/bep20:0xa2b726b1145a4773f68593cf171187d8ebe4d495': ['inj_bsc'],
    'eip155:56/bep20:0x2170ed0880ac9a755fd29b2688956bd959f933f8': ['eth_bsc'],
    'eip155:56/bep20:0xba2ae424d960c26247dd6c32edc70b295c744c43': ['doge_bsc'],
    'eip155:56/bep20:0x3ee2200efb3400fabb9aacf31297cbdd1d435d47': ['ada_bsc'],
    'eip155:56/bep20:0x2859e4544c4bb03966803b044a93563bd2d0dd4d': ['shib_bsc'],
    'eip155:56/bep20:0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82': ['cake_bsc'],
    'eip155:56/bep20:0x4b5c23cac08a567ecf0c1ffca8372a45a5d33743': ['farm_bsc'],
    'eip155:1/erc20:0xa0246c9032bc3a600820415ae600c6388619a14d': ['farm_ethereum'],
    'eip155:56/bep20:0x728c5bac3c3e370e372fc4671f9ef6916b814d8b': ['unfi_bsc'],
    'eip155:1/erc20:0x441761326490cacf7af299725b6292597ee822c2': ['unfi_ethereum'],
    'eip155:56/bep20:0x2003f7ba57ea956b05b85c60b4b2ceea9b111256': ['kmd_bsc'],
    'eip155:56/bep20:0xea998d307aca04d4f0a3b3036aba84ae2e409c0a': ['jst_bsc'],
    'eip155:1/erc20:0x41e5560054824ea6b0732e656e3ad64e20e94e45': ['cvc_ethereum'],
    'eip155:1/erc20:0x408e41876cccdc0f92210600ef50372656052a38': ['ren_ethereum'],
    'eip155:1/erc20:0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c': ['bnt_ethereum'],
    'eip155:56/bep20:0xa069008a669e2af00a86673d9d584cfb524a42cc': ['bnt_bsc'],
    'eip155:1/erc20:0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419': ['dia_ethereum'],
    'eip155:56/bep20:0x99956d38059cf7beda96ec91aa7bb2477e0901dd': ['dia_bsc'],
    'eip155:1/erc20:0x5732046a883704404f284ce41ffadd5b007fd668': ['blz_ethereum'],
    'eip155:56/bep20:0x935a544bf5816e3a7c13db2efe3009ffda0acda2': ['blz_bsc'],
    'eip155:56/bep20:0x6bff4fb161347ad7de4a625ae5aa3a1ca7077819': ['adx_bsc'],
    'eip155:1/erc20:0xade00c28244d5ce17d72e40330b1c318cd12b7c3': ['adx_ethereum'],
    'eip155:1/erc20:0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26': ['mdt_ethereum'],
    'eip155:56/bep20:0x668db7aa38eac6b40c9d13dbe61361dc4c4611d1': ['mdt_bsc'],
    'eip155:1/erc20:0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74': ['wtc_ethereum'],
    'eip155:56/bep20:0x52ce071bd9b1c4b00a0b92d298c512478cad67e8': ['comp_bsc'],
    'eip155:1/erc20:0xf8c3527cc04340b208c854e985240c02f7b7793f': ['front_ethereum'],
    'eip155:56/bep20:0x928e55dab735aa8260af3cedada18b5f70c72f1b': ['front_bsc'],
    'eip155:56/bep20:0xa1e6c58d503e4eee986167f45a063853cefe08c3': ['sun_bsc'],
    'eip155:1/erc20:0x4a220e6096b25eadb88358cb44068a3248254675': ['qnt_ethereum'],
    'eip155:1/erc20:0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206': ['nexo_ethereum'],
    'eip155:137/erc20:0x41b3966b4ff7b427969ddf5da3627d6aeae9a48e': ['nexo_polygon'],
    'eip155:56/bep20:0xb86abcb37c3a4b64f74f59301aff131a1becc787': ['zil_bsc'],
    'eip155:1/erc20:0xd33526068d116ce69f19a9ee46f0bd304f21a51f': ['rpl_ethereum'],
    'eip155:56/bep20:0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e': ['yfi_bsc'],
    'eip155:43114/erc20:0x9c9e5fd8bbc25984b178fdce6117defa39d2db39': ['busd_avaxc'],
    'eip155:137/erc20:0x9c9e5fd8bbc25984b178fdce6117defa39d2db39': ['busd_polygon'],
    'eip155:56/bep20:0xfd7b3a77848f1c2d67e05e54d78d174a0c850335': ['ont_bsc'],
    'eip155:56/bep20:0xfc3e14af0f0c2129a84cc013d48c70d682902874': ['waves_bsc'],
    'eip155:1/erc20:0xbbbbca6a901c926f240b89eacb641d8aec7aeafd': ['lrc_ethereum'],
    'eip155:56/bep20:0x66e4d38b20173f509a1ff5d82866949e4fe898da': ['lrc_bsc'],
    'eip155:1/erc20:0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac': ['storj_ethereum'],
    'eip155:56/bep20:0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b': ['knc_bsc'],
    'eip155:1/erc20:0xdefa4e8a7bcba345f687a2f1456f5edd9ce97202': ['knc_ethereum'],
    'eip155:1/erc20:0x967da4048cd07ab37855c090aaf366e4ce1b9f48': ['ocean_ethereum'],
    'eip155:56/bep20:0xdce07662ca8ebc241316a15b611c89711414dd1a': ['ocean_bsc'],
    'eip155:1/erc20:0xa117000000f279d81a1d3cc75430faa017fa5a2e': ['ant_ethereum'],
    'eip155:56/bep20:0x1f9f6a696c6fd109cd3956f45dc709d2b3902163': ['celr_bsc'],
    'eip155:1/erc20:0x4f9254c83eb525f9fcf346490bbb3ed28a81c667': ['celr_ethereum'],
    'eip155:1/erc20:0x6c6ee5e31d828de241282b9606c8e98ea48526e2': ['hot_ethereum'],
    'eip155:56/bep20:0x3d6545b08693dae087e957cb1180ee38b9e3c25e': ['etc_bsc'],
    'eip155:56/bep20:0x0f9e4d49f25de22c2202af916b681fbb3790497b': ['perl_bsc'],
    'eip155:1/erc20:0xeca82185adce47f39c684352b0439f030f860318': ['mda_ethereum'],
    'eip155:56/bep20:0x26433c8127d9b4e9b71eaa15111df99ea2eeb2f8': ['mana_bsc'],
    'eip155:1/erc20:0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9': ['ftt_ethereum'],
    'eip155:1/erc20:0xddb3422497e61e13543bea06989c0789117555c5': ['coti_ethereum'],
    'eip155:56/bep20:0xadbaf88b39d37dc68775ed1541f1bf83a5a45feb': ['coti_bsc'],
    'eip155:56/bep20:0xad6caeb32cd2c308980a548bd0bc5aa4306c6c18': ['band_bsc'],
    'eip155:1/erc20:0xba11d00c5f74255f56a5e366f4f77f5a186d7f55': ['band_ethereum'],
    'eip155:1/erc20:0x595832f8fc6bf59c85c527fec3740a1b7a361269': ['powr_ethereum'],
    'eip155:1/erc20:0x419d0d8bdd9af5e606ae2232ed285aff190e711b': ['fun_ethereum'],
    'eip155:1/erc20:0x42476f744292107e34519f9c357927074ea3f75d': ['loom_ethereum'],
    'eip155:56/bep20:0xe6ce27025f13f5213bbc560dc275e292965a392f': ['loom_bsc'],
    'eip155:56/bep20:0xa3f020a5c92e15be13caf0ee5c95cf79585eecc9': ['elf_bsc'],
    'eip155:1/erc20:0xbf2179859fc6d5bee9bf9158632dc51678a4100e': ['elf_ethereum'],
    'eip155:56/bep20:0xcc42724c6683b7e57334c4e856f4c9965ed682bd': ['matic_bsc'],
    'eip155:56/bep20:0x8595f9da7b868b1822194faed312235e43007b49': ['bttold_bsc'],
    'eip155:56/bep20:0x352cb5e19b12fc216548a2677bd0fce83bae434b': ['btt_bsc'],
    'eip155:56/bep20:0xbf5140a22578168fd562dccf235e5d43a02ce9b1': ['uni_bsc'],
    'eip155:1/erc20:0xba100000625a3754423978a60c9317c58a424e3d': ['bal_ethereum'],
    'eip155:56/bep20:0xd4ed60d8368a92b5f1ca33af61ef2a94714b2d46': ['bal_bsc'],
    'eip155:56/bep20:0xce7de646e7208a4ef112cb6ed5038fa6cc6b12e3': ['trx_bsc'],
    'eip155:1/erc20:0x8207c1ffc5b6804f6024322ccf34f29c3541ae26': ['ogn_ethereum'],
    'eip155:56/bep20:0x9c1962e0ac2a370ab4c4f4eecba6483d8764c4b2': ['ogn_bsc'],
    'eip155:56/bep20:0x031b41e504677879370e9dbcf937283a8691fa7f': ['fet_bsc'],
    'eip155:1/erc20:0xaea46a60368a7bd060eec7df8cba43b7ef41ad85': ['fet_ethereum'],
    'eip155:56/bep20:0x7083609fce4d1d8dc0c979aab8c869ea2c873402': ['dot_bsc'],
    'eip155:56/bep20:0x4338665cbb7b2485a8855a139b75d5e34ab0db94': ['ltc_bsc'],
    'eip155:56/bep20:0xb2bd0749dbe21f623d9baba856d3b0f0e1bfec9c': ['dusk_bsc'],
    'eip155:1/erc20:0x940a2db1b7008b6c776d4faaca729d6d4a4aa551': ['dusk_ethereum'],
    'eip155:56/bep20:0x5f0da599bb2cccfcf6fdfd7d81743b6020864350': ['mkr_bsc'],
    'eip155:56/bep20:0x16939ef78684453bfdfb47825f8a5f714f12623a': ['xtz_bsc'],
    'eip155:56/bep20:0x715d400f88c167884bbcc41c5fea407ed4d2f8a0': ['axs_bsc'],
    'eip155:1/erc20:0x607f4c5bb672230e8672085532f7e901544a7375': ['rlc_ethereum'],
    'eip155:1/erc20:0x1776e1f26f98b1a5df9cd347953a26dd3cb46671': ['nmr_ethereum'],
    'eip155:56/bep20:0x46d0dac0926fa16707042cadc23f1eb4141fe86b': ['snm_bsc'],
    'eip155:1/erc20:0x46d0dac0926fa16707042cadc23f1eb4141fe86b': ['snm_ethereum'],
    'eip155:1/erc20:0x4575f41308ec1483f3d399aa9a2826d74da13deb': ['oxt_ethereum'],
    'eip155:1/erc20:0xde7d85157d9714eadf595045cc12ca4a5f3e2adb': ['stpt_ethereum'],
    'eip155:1/erc20:0xf433089366899d83a9f26a773d59ec7ecf30355e': ['mtl_ethereum'],
    'eip155:1/erc20:0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724': ['vib_ethereum'],
    'eip155:56/bep20:0xd5d0322b6bab6a762c79f8c81a0b674778e13aed': ['firo_bsc'],
    'eip155:56/bep20:0x1ce0c2827e2ef14d5c4f29a091d735a204794041': ['avax_bsc'],
    'eip155:56/bep20:0xc762043e211571eb34f1ef377e5e8e76914962f9': ['ape_bsc'],
    'eip155:56/bep20:0x1fa4a73a3f0133f0025378af00236f3abdee5d63': ['near_bsc'],
    'eip155:56/bep20:0xc943c5320b9c18c153d1e2d12cc3074bebfb31a2': ['flow_bsc'],
    'eip155:1/erc20:0xe3c408bd53c31c085a1746af401a4042954ff740': ['gmt_ethereum'],
    'eip155:56/bep20:0x570a5d26f7765ecb712c0924e4de545b89fd43df': ['sol_bsc'],
    'eip155:56/bep20:0x4d5ac5cc4f8abdf2ec2cb986c00c382369f787d4': ['ilv_bsc'],
    'eip155:1/erc20:0x767fe9edc9e0df98e07454847909b5e959d7ca0e': ['ilv_ethereum'],
    'eip155:1/erc20:0x888888848b652b3e3a0f34c96e00eec0f3a23f72': ['tlm_ethereum'],
    'eip155:56/bep20:0x2222227e22102fe3322098e4cbfe18cfebd57c95': ['tlm_bsc'],
    'eip155:56/bep20:0xaec945e04baf28b135fa7c640f624f8d90f1c3a6': ['c98_bsc'],
    'eip155:1/erc20:0xae12c5930881c53715b369cec7606b70d8eb229f': ['c98_ethereum'],
    'eip155:56/bep20:0x2cd96e8c3ff6b5e01169f6e3b61d28204e7810bb': ['lblock_bsc'],
    'eip155:1/erc20:0x1456688345527be1f37e9e627da0837d6f08c925': ['usdp_ethereum'],
    'eip155:137/erc20:0x430ef9263e76dae63c84292c3409d61c598e9682': ['pyr_polygon'],
    'eip155:1/erc20:0x430ef9263e76dae63c84292c3409d61c598e9682': ['pyr_ethereum'],
    'eip155:56/bep20:0xf78d2e7936f5fe18308a3b2951a93b6c4a41f5e2': ['om_bsc'],
    'eip155:1/erc20:0x720cd16b011b987da3518fbf38c3071d4f0d1495': ['flux_ethereum'],
    'eip155:56/bep20:0xaff9084f2374585879e8b434c399e29e80cce635': ['flux_bsc'],
    'eip155:1/erc20:0x4691937a7508860f876c9c0a2a617e7d9e945d4b': ['woo_ethereum'],
    'eip155:56/bep20:0x4691937a7508860f876c9c0a2a617e7d9e945d4b': ['woo_bsc'],
    'eip155:56/bep20:0x045c4324039da91c52c55df5d785385aab073dcf': ['cfx_bsc'],
    'eip155:1/erc20:0x7420b4b9a0110cdc71fb720908340c03f9bc03ec': ['jasmy_ethereum'],
    'eip155:56/bep20:0x15669cf161946c09a8b207650bfbb00e3d8a2e3e': ['jasmy_bsc'],
    'eip155:1/erc20:0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b': ['cvx_ethereum'],
    'eip155:1/erc20:0xff20817765cb7f73d4bde2e66e067e58d11095c2': ['amp_ethereum'],
    'eip155:1/erc20:0xc944e90c64b2c07662a292be6244bdf05cda44a7': ['grt_ethereum'],
    'eip155:137/erc20:0x5fe2b58c013d7601147dcdd68c143a77499f5531': ['grt_polygon'],
    'eip155:1/erc20:0x320623b8e4ff03373931769a31fc52a4e78b5d70': ['rsr_ethereum'],
    'eip155:56/bep20:0x965f527d9159dce6288a2219db51fc6eef120dd1': ['bsw_bsc'],
    'eip155:56/bep20:0x8f0528ce5ef7b51152a59745befdd91d97091d2f': ['alpaca_bsc'],
    'eip155:56/bep20:0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377': ['mbox_bsc'],
    'eip155:56/bep20:0xf9cec8d50f6c8ad3fb6dccec577e05aa32b224fe': ['chr_bsc'],
    'eip155:1/erc20:0x8a2279d4a90b6fe1c4b30fa660cc9f926797baa2': ['chr_ethereum'],
    'eip155:56/bep20:0x8da443f84fea710266c8eb6bc34b71702d033ef2': ['ctsi_bsc'],
    'eip155:1/erc20:0x15d4c048f83bd7e37d49ea4c83a07267ec4203da': ['gala_ethereum'],
    'eip155:56/bep20:0xac51066d7bec65dc4589368da368b212745d63e8': ['alice_bsc'],
    'eip155:1/erc20:0xac51066d7bec65dc4589368da368b212745d63e8': ['alice_ethereum'],
    'eip155:1/erc20:0xed04915c23f00a313a544955524eb7dbd823143d': ['ach_ethereum'],
    'eip155:56/bep20:0xbc7d6b50616989655afd682fb42743507003056d': ['ach_bsc'],
    'eip155:56/bep20:0x9f589e3eabe42ebc94a44727b3f3531c0c877809': ['tko_bsc'],
    'eip155:1/erc20:0x91af0fbb28aba7e31403cb457106ce79397fd4e6': ['aergo_ethereum'],
    'eip155:1/erc20:0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55': ['super_ethereum'],
    'eip155:56/bep20:0x51ba0b044d96c3abfca52b64d733603ccc4f0d4d': ['super_bsc'],
    'eip155:1/erc20:0xba50933c268f567bdc86e1ac131be072c6b0b71a': ['arpa_ethereum'],
    'eip155:56/bep20:0x6f769e65c14ebd1f68817f5f1dcdb61cfa2d6f7e': ['arpa_bsc'],
    'eip155:1/erc20:0x949d48eca67b17269629c7194f4b727d4ef9e5d6': ['mc_ethereum'],
    'eip155:56/bep20:0x949d48eca67b17269629c7194f4b727d4ef9e5d6': ['mc_bsc'],
    'eip155:1/erc20:0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14': ['bel_ethereum'],
    'eip155:56/bep20:0x8443f091997f06a61670b735ed92734f5628692f': ['bel_bsc'],
    'eip155:56/bep20:0xa2120b9e674d3fc3875f415a7df52e382f141225': ['ata_bsc'],
    'eip155:1/erc20:0xa2120b9e674d3fc3875f415a7df52e382f141225': ['ata_ethereum'],
    'eip155:56/bep20:0x20de22029ab63cf9a7cf5feb2b737ca1ee4c82a6': ['chess_bsc'],
    'eip155:1/erc20:0x5faa989af96af85384b8a938c2ede4a7378d9875': ['gal_ethereum'],
    'eip155:56/bep20:0xe4cc45bb5dbda06db6183e8bf016569f40497aa5': ['gal_bsc'],
    'eip155:1/erc20:0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7': ['akro_ethereum'],
    'eip155:56/bep20:0xe02df9e3e622debdd69fb838bb799e3f168902c5': ['bake_bsc'],
    'eip155:1/erc20:0x5a98fcbea516cf06857215779fd812ca3bef1b32': ['ldo_ethereum'],
    'eip155:1/erc20:0x3597bfd533a99c9aa083587b074434e61eb0a258': ['dent_ethereum'],
    'eip155:56/bep20:0x2b3f34e9d4b127797ce6244ea341a83733ddd6e4': ['floki_bsc'],
    'eip155:1/erc20:0xcf0c122c6b73ff809c693db761e7baebe62b6a2e': ['floki_ethereum'],
    'eip155:10/erc20:0x4200000000000000000000000000000000000042': ['op_optimism'],
    'eip155:56/bep20:0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb': ['zec_bsc'],
    'eip155:1/erc20:0x8ce9137d39326ad0cd6491fb5cc0cba0e089b6a9': ['sxp_ethereum'],
    'eip155:56/bep20:0x47bead2563dcbf3bf2c9407fea4dc236faba485a': ['sxp_bsc'],
    'eip155:1/erc20:0x0f17bc9a994b87b5225cfb6a2cd4d667adb4f20b': ['jeur_ethereum'],
    'eip155:1/erc20:0x53dfea0a8cc2a2a2e425e1c174bc162999723ea0': ['jchf_ethereum'],
    'eip155:1/erc20:0x7409856cae628f5d578b285b45669b36e7005283': ['jgbp_ethereum'],
    'eip155:137/erc20:0x4e3decbb3645551b8a19f0ea1678079fcb33fb4c': ['jeur_polygon'],
    'eip155:137/erc20:0xbd1463f02f61676d53fd183c2b19282bff93d099': ['jchf_polygon'],
    'eip155:137/erc20:0x767058f11800fba6a682e73a6e79ec5eb74fac8c': ['jgbp_polygon'],
    'eip155:137/erc20:0x8ca194a3b22077359b5732de53373d4afc11dee3': ['jcad_polygon'],
    'eip155:137/erc20:0xa926db7a4cc0cb1736d5ac60495ca8eb7214b503': ['jsgd_polygon'],
    'eip155:56/bep20:0x23b8683ff98f9e4781552dfe6f12aa32814924e8': ['jeur_bsc'],
    'eip155:56/bep20:0x7c869b5a294b1314e985283d01c702b62224a05f': ['jchf_bsc'],
    'eip155:56/bep20:0x048e9b1ddf9ebbb224812372280e94ccac443f9e': ['jgbp_bsc'],
    'eip155:137/erc20:0x197e5d6ccff265ac3e303a34db360ee1429f5d1a': ['jsek_polygon'],
    'eip155:137/erc20:0xcb7f1ef7246d1497b985f7fc45a1a31f04346133': ['jaud_polygon'],
    'eip155:137/erc20:0x8343091f2499fd4b6174a46d067a920a3b851ff9': ['jjpy_polygon'],
    'eip155:56/bep20:0x6b8b9ae0627a7622c593a1696859ca753c61a670': ['jzar_bsc'],
    'eip155:100/erc20:0x9fb1d52596c44603198fb0aee434fac3a679f702': ['jeur_gnosis'],
    'eip155:100/erc20:0x2d5563da42b06fbbf9c67b7dc073cf6a7842239e': ['jchf_gnosis'],
    'eip155:43114/erc20:0x9fb1d52596c44603198fb0aee434fac3a679f702': ['jeur_avaxc'],
    'eip155:43114/erc20:0x2d5563da42b06fbbf9c67b7dc073cf6a7842239e': ['jchf_avaxc'],
    'eip155:1/erc20:0xdb25f211ab05b1c97d595516f45794528a807ad8': ['eurs_ethereum'],
    'eip155:137/erc20:0xe111178a87a3bff0c8d18decba5798827539ae99': ['eurs_polygon'],
    'eip155:137/erc20:0x7bdf330f423ea880ff95fc41a280fd5ecfd3d09f': ['eurt_polygon'],
    'eip155:137/erc20:0xa3fa99a148fa48d14ed51d610c367c61876997f1': ['mimatic_polygon'],
    'eip155:43114/erc20:0x5c49b268c9841aff1cc3b0a418ff5c3442ee3f3b': ['mimatic_avaxc'],
    'eip155:1/erc20:0xa47c8bf37f92abed4a126bda807a7b7498661acd': ['ustc_ethereum'],
    'eip155:137/erc20:0xe6469ba6d2fd6130788e0ea9c0a0515900563b59': ['ustc_polygon'],
    'eip155:43114/erc20:0xb599c3590f42f8f995ecfa0f85d2980b76862fc1': ['ustc_avaxc'],
    'eip155:1/erc20:0x1abaea1f7c830bd89acc67ec4af516284b1bc33c': ['euroc_ethereum'],
    'eip155:1/erc20:0x5f98805a4e8be255a32880fdec7f6728c6568ba0': ['lusd_ethereum'],
    'eip155:10/erc20:0xc40f949f8a4e094d1b49a23ea9241d289b7b2819': ['lusd_optimism'],
    'eip155:1/erc20:0xb4272071ecadd69d933adcd19ca99fe80664fc08': ['xchf_ethereum'],
    'eip155:10/erc20:0xe4f27b04cc7729901876b44f4eaa5102ec150265': ['xchf_optimism'],
    'eip155:10/erc20:0x79af5dd14e855823fa3e9ecacdf001d99647d043': ['jeur_optimism'],
    'eip155:1/erc20:0x89d71dfbdd6ebecd0dfe27d55189f903169d2991': ['thdx_ethereum'],
    'eip155:56/bep20:0x0409633a72d846fc5bbe2f98d88564d35987904d': ['phb_bsc'],
    'eip155:56/bep20:0x65d9033cff96782394dab5dbef17fa771bbe1732': ['store_bsc'],
    'eip155:43114/erc20:0x31c994ac062c1970c086260bc61babb708643fac': ['xeta_avaxc'],
    'eip155:56/bep20:0x6a0b66710567b6beb81a71f7e9466450a91a384b': ['pex_bsc'],
    'eip155:56/bep20:0xcd76bc49a69bcdc5222d81c18d4a04dc8a387297': ['vs_bsc'],
    'eip155:1/erc20:0x72b886d09c117654ab7da13a14d603001de0b777': ['xdefi_ethereum'],
    'eip155:56/bep20:0xa8c2b8eec3d368c0253ad3dae65a5f2bbb89c929': ['ctk_bsc'],
    'eip155:1/erc20:0x8f693ca8d21b157107184d29d398a8d082b38b76': ['data_ethereum'],
    'eip155:137/erc20:0x3a9a81d576d83ff21f26f325066054540720fc34': ['data_polygon'],
    'eip155:56/bep20:0x0864c156b3c5f69824564dec60c629ae6401bf2a': ['data_bsc'],
    'eip155:56/bep20:0x2c44b726adf1963ca47af88b284c06f30380fc78': ['people_bsc'],
    'eip155:1/erc20:0x7a58c0be72be218b41c608b7fe7c5bb630736c71': ['people_ethereum'],
    'eip155:56/bep20:0x0ef2e7602add1733bfdb17ac3094d0421b502ca3': ['xec_bsc'],
    'eip155:1/erc20:0x0391d2021f89dc339f60fff84546ea23e337750f': ['bond_ethereum'],
    'eip155:1/erc20:0xbc396689893d065f41bc2c6ecbee5e0085233447': ['perp_ethereum'],
    'eip155:56/bep20:0x4e7f408be2d4e9d60f49a64b89bb619c84c7c6f5': ['perp_bsc'],
    'eip155:56/bep20:0x4e7e8579a9edc6283011be942537baf9284bebe1': ['city_bsc'],
    'eip155:1/erc20:0xfe3e6a25e6b192a42a44ecddcd13796471735acf': ['reef_ethereum'],
    'eip155:56/bep20:0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e': ['reef_bsc'],
    'eip155:56/bep20:0xbc5609612b7c44bef426de600b5fd1379db2ecf1': ['psg_bsc'],
    'eip155:1/erc20:0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24': ['rndr_ethereum'],
    'eip155:1/erc20:0x40986a85b4cfcdb054a6cbfb1210194fee51af88': ['ufarm_ethereum'],
    'eip155:56/bep20:0x0a356f512f6fce740111ee04ab1699017a908680': ['ufarm_bsc'],
    'eip155:137/erc20:0xa7305ae84519ff8be02484cda45834c4e7d13dd6': ['ufarm_polygon'],
    'eip155:56/bep20:0xa64455a4553c9034236734faddaddbb64ace4cc7': ['santos_bsc'],
    'eip155:1/erc20:0x0d438f3b5175bebc262bf23753c1e53d03432bde': ['wnxm_ethereum'],
    'eip155:56/bep20:0x2794dad4077602ed25a88d03781528d1637898b4': ['vite_bsc'],
    'eip155:137/erc20:0xe5417af564e4bfda1c483642db72007871397896': ['gns_polygon'],
    'eip155:1/erc20:0xcdf7028ceab81fa0c6971208e83fa7872994bee5': ['t_ethereum'],
    'eip155:56/bep20:0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb': ['sfp_bsc'],
    'eip155:56/bep20:0xc40c9a843e1c6d01b7578284a9028854f6683b1b': ['juv_bsc'],
    'eip155:1/erc20:0x8f8221afbb33998d8584a2b05749ba73c37a938a': ['req_ethereum'],
    'eip155:56/bep20:0x4a9a2b2b04549c3927dd2c9668a5ef3fca473623': ['df_bsc'],
    'eip155:1/erc20:0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0': ['df_ethereum'],
    'eip155:56/bep20:0x658a109c5900bc6d2357c87549b651670e5b0539': ['for_bsc'],
    'eip155:1/erc20:0x1fcdce58959f536621d76f5b7ffb955baa5a672f': ['for_ethereum'],
    'eip155:56/bep20:0xf79037f6f6be66832de4e7516be52826bc3cbcc4': ['hard_bsc'],
    'eip155:1/erc20:0x4574562e9310a94f9ca962bd23168d8a06875b1a': ['troy_ethereum'],
    'eip155:56/bep20:0x6d41f64c567acbf36f88763306ff6fb50ff61458': ['troy_bsc'],
    'eip155:1/erc20:0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7': ['skl_ethereum'],
    'eip155:56/bep20:0xae9269f27437f0fcbc232d39ec814844a51d6b8f': ['burger_bsc'],
    'eip155:56/bep20:0xa260e12d2b924cb899ae80bb58123ac3fee1e2f0': ['hook_bsc'],
    'eip155:56/bep20:0xaf41054c1487b0e5e2b9250c0332ecbce6ce9d71': ['epx_bsc'],
    'eip155:56/bep20:0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63': ['xvs_bsc'],
    'eip155:1/erc20:0x2dff88a56767223a5529ea5960da7a3f5f766406': ['id_ethereum'],
    'eip155:56/bep20:0x2dff88a56767223a5529ea5960da7a3f5f766406': ['id_bsc'],
    'eip155:56/bep20:0x77d547256a2cd95f32f67ae0313e450ac200648d': ['lazio_bsc'],
    'eip155:1/erc20:0x3da932456d082cba208feb0b096d49b202bf89c8': ['dego_ethereum'],
    'eip155:56/bep20:0x3da932456d082cba208feb0b096d49b202bf89c8': ['dego_bsc'],
    'eip155:1/erc20:0xbbc2ae13b23d715c30720f079fcd9b4a74093505': ['ern_ethereum'],
    'eip155:1/erc20:0x6c5ba91642f10282b576d91922ae6448c9d52f4e': ['pha_ethereum'],
    'eip155:56/bep20:0x0112e557d400474717056c4e6d40edd846f38351': ['pha_bsc'],
    'eip155:56/bep20:0x18e37f96628db3037d633fe4d469fb1933a63c5b': ['mbl_bsc'],
    'eip155:1/erc20:0x589891a198195061cb8ad1a75357a3b7dbadd7bc': ['cos_ethereum'],
    'eip155:56/bep20:0x96dd399f9c3afda1f194182f71600f1b65946501': ['cos_bsc'],
    'eip155:1/erc20:0x0b38210ea11411557c13457d4da7dc6ea731b88a': ['api3_ethereum'],
    'eip155:1/erc20:0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664': ['qkc_ethereum'],
    'eip155:56/bep20:0xa1434f1fc3f437fa33f7a781e041961c0205b5da': ['qkc_bsc'],
    'eip155:1/erc20:0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096': ['auction_ethereum'],
    'eip155:56/bep20:0x1188d953afc697c031851169eef640f23ac8529c': ['auction_bsc'],
    'eip155:1/erc20:0x3472a5a71965499acd81997a54bba8d852c6e53d': ['badger_ethereum'],
    'eip155:56/bep20:0x9fb9a33956351cf4fa040f65a13b835a3c8764e3': ['multi_bsc'],
    'eip155:1/erc20:0x71ab77b7dbb4fa7e017bc15090b2163221420282': ['high_ethereum'],
    'eip155:56/bep20:0x5f4bde007dc06b867f86ebfe4802e34a1ffeed63': ['high_bsc'],
    'eip155:1/erc20:0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0': ['trb_ethereum'],
    'eip155:1/erc20:0x4c19596f5aaff459fa38b0f7ed92f11ae6543784': ['tru_ethereum'],
    'eip155:56/bep20:0xb4fcdcb8a0b29247466720ff81587d1a6f4fc4d7': ['tru_bsc'],
    'eip155:1/erc20:0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2': ['drep_ethereum'],
    'eip155:56/bep20:0xec583f25a049cc145da9a256cdbe9b6201a705ff': ['drep_bsc'],
    'eip155:56/bep20:0x9c65ab58d8d978db963e63f2bfb7121627e3a739': ['mdx_bsc'],
    'eip155:1/erc20:0x4b9278b94a1112cad404048903b8d343a810b07e': ['hifi_ethereum'],
    'eip155:56/bep20:0x8cd6e29d3686d24d3c2018cee54621ea0f89313b': ['nuls_bsc'],
    'eip155:1/erc20:0x090185f2135308bad17527004364ebcc2d37e5f6': ['spell_ethereum'],
    'eip155:43114/erc20:0xce1bffbd5374dac86a2893119683f4911a2f7814': ['spell_avaxc'],
    'eip155:1/erc20:0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38': ['pundix_ethereum'],
    'eip155:1/erc20:0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0': ['fxs_ethereum'],
    'eip155:56/bep20:0xde2f075f6f14eb9d96755b24e416a53e736ca363': ['fxs_bsc'],
    'eip155:56/bep20:0xf05e45ad22150677a017fbd94b84fbb63dc9b44c': ['og_bsc'],
    'eip155:56/bep20:0x250632378e573c6be1ac2f97fcdf00515d0aa91b': ['beth_bsc'],
    'eip155:1/erc20:0xbe1a001fe942f96eea22ba08783140b9dcc09d28': ['beta_ethereum'],
    'eip155:56/bep20:0xbe1a001fe942f96eea22ba08783140b9dcc09d28': ['beta_bsc'],
    'eip155:1/erc20:0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54': ['ssv_ethereum'],
    'eip155:1/erc20:0xdbdb4d16eda451d0503b854cf79d55697f90c8df': ['alcx_ethereum'],
    'eip155:1/erc20:0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6': ['stg_ethereum'],
    'eip155:56/bep20:0xb0d502e938ed5f4df2e681fe6e419ff29631d62b': ['stg_bsc'],
    'eip155:137/erc20:0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590': ['stg_polygon'],
    'eip155:43114/erc20:0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590': ['stg_avaxc'],
    'eip155:1/erc20:0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988': ['tvk_ethereum'],
    'eip155:1/erc20:0x89ab32156e46f46d02ade3fecbe5fc4243b9aaed': ['pnt_ethereum'],
    'eip155:56/bep20:0xdaacb0ab6fb34d24e8a67bfa14bf4d95d4c7af92': ['pnt_bsc'],
    'eip155:1/erc20:0x5cf04716ba20127f1e2297addcf4b5035000c9eb': ['nkn_ethereum'],
    'eip155:1/erc20:0xb50721bcf8d664c30412cfbc6cf7a15145234ad1': ['arb_ethereum'],
    'eip155:1/erc20:0x61e90a50137e1f645c9ef4a0d3a4f01477738406': ['loka_ethereum'],
    'eip155:1/erc20:0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1': ['cvp_ethereum'],
    'eip155:56/bep20:0x5ec3adbdae549dce842e24480eb2434769e22b2e': ['cvp_bsc'],
    'eip155:56/bep20:0x80d5f92c2c8c682070c95495313ddb680b267320': ['asr_bsc'],
    'eip155:1/erc20:0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd': ['dodo_ethereum'],
    'eip155:56/bep20:0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2': ['dodo_bsc'],
    'eip155:1/erc20:0xb59490ab09a0f526cc7305822ac65f2ab12f9723': ['lit_ethereum'],
    'eip155:56/bep20:0xb59490ab09a0f526cc7305822ac65f2ab12f9723': ['lit_bsc'],
    'eip155:56/bep20:0x25e9d05365c867e59c1904e7463af9f312296f9e': ['atm_bsc'],
    'eip155:1/erc20:0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44': ['kp3r_ethereum'],
    'eip155:1/erc20:0xa1faa113cbe53436df28ff0aee54275c13b40975': ['alpha_ethereum'],
    'eip155:56/bep20:0xa1faa113cbe53436df28ff0aee54275c13b40975': ['alpha_bsc'],
    'eip155:1/erc20:0xec67005c4e498ec7f55e092bd1d35cbc47c91892': ['mln_ethereum'],
    'eip155:1/erc20:0x0f2d719407fdbeff09d87557abb7232601fd9f29': ['syn_ethereum'],
    'eip155:10/erc20:0x5a5fff6f753d7c11a56a52fe47a177a87e431655': ['syn_optimism'],
    'eip155:56/bep20:0xa4080f1778e69467e905b8d6f72f6e441f9e9484': ['syn_bsc'],
    'eip155:137/erc20:0xf8f9efc0db77d8881500bb06ff5d6abc3070e695': ['syn_polygon'],
    'eip155:43114/erc20:0x1f1e7c893855525b303f99bdf5c3c05be09ca251': ['syn_avaxc'],
    'eip155:1/erc20:0x3be7bf1a5f23bd8336787d0289b70602f1940875': ['vidt_ethereum'],
    'eip155:56/bep20:0x9c4a515cd72d27a4710571aca94858a53d9278d5': ['vidt_bsc'],
    'eip155:1/erc20:0xc4c7ea4fab34bd9fb9a5e1b1a98df76e26e6407c': ['cocos_ethereum'],
    'eip155:56/bep20:0xab301dae71f5b386c566f484e636aee60318f12f': ['cocos_bsc'],
    'eip155:1/erc20:0x6dea81c8171d0ba574754ef6f8b412f2ed88c54d': ['lqty_ethereum'],
    'eip155:1/erc20:0xf17e65822b568b3903685a7c9f496cf7656cc6c2': ['bico_ethereum'],
    'eip155:1/erc20:0x25f8087ead173b73d6e8b84329989a8eea16cf73': ['ygg_ethereum'],
    'eip155:56/bep20:0x13ab6739368a4e4abf24695bf52959224367391f': ['ygg_bsc'],
    'eip155:1/erc20:0xb3999f658c0391d94a37f7ff328f3fec942bcadc': ['hft_ethereum'],
    'eip155:56/bep20:0x44ec807ce2f4a6f2737a92e985f318d035883e47': ['hft_bsc'],
    'eip155:1/erc20:0x0de05f6447ab4d22c8827449ee4ba2d5c288379b': ['ooki_ethereum'],
    'eip155:1/erc20:0x77fba179c79de5b7653f68b5039af940ada60ce0': ['forth_ethereum'],
    'eip155:1/erc20:0x3f382dbd960e3a9bbceae22651e88158d2791550': ['ghst_ethereum'],
    'eip155:137/erc20:0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7': ['ghst_polygon'],
    'eip155:56/bep20:0x287880ea252b52b63cc5f40a2d3e5a44aa665a76': ['alpine_bsc'],
    'eip155:1/erc20:0x4b5f49487ea7b3609b1ad05459be420548789f1f': ['lever_ethereum'],
    'eip155:1/erc20:0xb705268213d593b8fd88d3fdeff93aff5cbdcfae': ['idex_ethereum'],
    'eip155:56/bep20:0x0856978f7ffff0a2471b4520e3521c4b3343e36f': ['idex_bsc'],
    'eip155:1/erc20:0xde4ee8057785a7e8e800db58f9784845a5c2cbd6': ['dexe_ethereum'],
    'eip155:56/bep20:0x039cb485212f996a9dbb85a9a75d898f94d38da6': ['dexe_bsc'],
    'eip155:1/erc20:0x8642a849d0dcb7a15a974794668adcfbe4794b56': ['pros_ethereum'],
    'eip155:56/bep20:0xed8c8aa8299c10f067496bb66f8cc7fb338a3405': ['pros_bsc'],
    'eip155:1/erc20:0xfc82bb4ba86045af6f327323a46e80412b91b27d': ['prom_ethereum'],
    'eip155:56/bep20:0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5': ['prom_bsc'],
    'eip155:1/erc20:0x58b6a8a3302369daec383334672404ee733ab239': ['lpt_ethereum'],
    'eip155:56/bep20:0xf7de7e8a6bd59ed41a4b5fe50278b3b7f31384df': ['rdnt_bsc'],
    'eip155:56/bep20:0x49f2145d6366099e13b10fbf80646c0f377ee7f6': ['porto_bsc'],
    'eip155:1/erc20:0x081131434f93063751813c619ecca9c4dc7862a3': ['dar_ethereum'],
    'eip155:56/bep20:0x23ce9e926048273ef83be0a3a8ba9cb6d45cd978': ['dar_bsc'],
    'eip155:1/erc20:0x2ba592f78db6436527729929aaf6c908497cb200': ['cream_ethereum'],
    'eip155:56/bep20:0xd4cb328a82bdf5f03eb737f37fa6b370aef3e888': ['cream_bsc'],
    'eip155:56/bep20:0xaef0d72a118ce24fee3cd1d43d383897d05b4e99': ['win_bsc'],
    'eip155:1/erc20:0xd01409314acb3b245cea9500ece3f6fd4d70ea30': ['lto_ethereum'],
    'eip155:56/bep20:0x857b222fc79e1cbbf8ca5f78cb133d1b7cf34bbd': ['lto_bsc'],
    'eip155:1/erc20:0x3c4b6e6e1ea3d4863700d7f76b36b7f3d3f13e3d': ['vgx_ethereum'],
    'eip155:1/erc20:0x57b946008913b82e4df85f501cbaed910e58d26c': ['pond_ethereum'],
    'eip155:56/bep20:0xa1428370f540b4c4e319224165ecae513a391f77': ['pond_bsc'],
    'eip155:1/erc20:0x3e9bc21c9b189c09df3ef1b824798658d5011937': ['lina_ethereum'],
    'eip155:56/bep20:0x762539b45a1dcce3d36d080f74d1aed37844b878': ['lina_bsc'],
    'eip155:1/erc20:0x0202be363b8a4820f3f4de7faf5224ff05943ab1': ['uft_ethereum'],
    'eip155:56/bep20:0x2645d5f59d952ef2317c8e0aaa5a61c392ccd44d': ['uft_bsc'],
    'eip155:1/erc20:0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d': ['fis_ethereum'],
    'eip155:56/bep20:0xf4bafaeae73a4a7c8b6479970075e91e641fb1fc': ['fis_bsc'],
    'eip155:1/erc20:0x31c8eacbffdd875c74b94b077895bd78cf1e64a3': ['rad_ethereum'],
    'eip155:1/erc20:0x4dc3643dbc642b72c158e7f3d2ff232df61cb6ce': ['amb_ethereum'],
    'eip155:1/erc20:0xea11755ae41d889ceec39a63e6ff75a02bc1c00d': ['ctxc_ethereum'],
    'eip155:1/erc20:0xd996035db82cae33ba1f16fdf23b816e5e9faabb': ['bns_ethereum'],
    'eip155:1/erc20:0x6982508145454ce325ddbe47a25d4ec3d2311933': ['pepe_ethereum'],
    'eip155:56/bep20:0xbdeae1ca48894a1759a8374d63925f21f2ee2639': ['edu_bsc'],
    'eip155:1/erc20:0x701c244b988a513c945973defa05de933b23fe1d': ['oax_ethereum'],
    'eip155:56/bep20:0x5b1f874d0b0c5ee17a495cbb70ab8bf64107a3bd': ['bnx_bsc'],
};
// explodes and inverts the assetId => tokenId[] map by creating a 1to1 token => assetId mapping
const invertMap = () => {
    const invertedMap = {};
    (0, entries_1.default)(exports.AssetIdToOnRamperIdMap).flatMap(([assetId, idList]) => idList.forEach(id => {
        invertedMap[id] = assetId;
    }));
    return invertedMap;
};
const OnRamperIdToAssetIdMap = invertMap();
const getOnRamperSupportedAssets = () => {
    (0, entries_1.default)(exports.AssetIdToOnRamperIdMap).map(([assetId, tokenId]) => ({
        assetId,
        token: tokenId,
    }));
};
exports.getOnRamperSupportedAssets = getOnRamperSupportedAssets;
const onRamperTokenIdToAssetId = (tokenId) => OnRamperIdToAssetIdMap[tokenId];
exports.onRamperTokenIdToAssetId = onRamperTokenIdToAssetId;
const assetIdToOnRamperTokenList = (assetId) => exports.AssetIdToOnRamperIdMap[assetId];
exports.assetIdToOnRamperTokenList = assetIdToOnRamperTokenList;
